import type { BillingInterval, PaidPlanId, Price } from './account';

/** Published USD prices used by mock billing and shown while Paddle prices are unavailable. */
const pricesFor = (monthlyCents: number): Readonly<Record<BillingInterval, Price>> => ({
  month: { amount: monthlyCents, currency: 'usd', interval: 'month' },
  year: { amount: monthlyCents * 10, currency: 'usd', interval: 'year' },
});

export const PUBLISHED_PLAN_PRICES: Readonly<
  Record<PaidPlanId, Readonly<Record<BillingInterval, Price>>>
> = {
  plus: pricesFor(500),
  pro: pricesFor(1_500),
  max: pricesFor(3_000),
};
